const translationsEn = {
    'contact-field-tooltip': 'You can use any of the following field names: {{list}}. You can also use any other field imported into the mailing list, for example: "City". Uppercase and lowercase letters are not case-sensitive.',
    'Element documentation': 'Element description',
    'Process documentation': 'Workflow description',
    'Documentation': 'Description',
    'Create intermediate/boundary event': 'Create intermediate event',
    'Append intermediate/boundary event': 'Add intermediate event',
    'Intermediate throw event': 'Intermediate event',
    'Intermediate Throw Event': 'Intermediate Event',
    'Process': 'Workflow',
    'Process ID': 'Workflow ID',
    'Process name': 'Workflow name',
    'User Task': 'Status change task',
    'User task': 'Status change task',
    'Create user task': 'Create status change task',
    'Append user task': 'Add status change task',
    'Create task': 'Create task (without action)',
    'Append task': 'Append task (without action)',
    'Task': 'Task (without action)',
    'Create service task': 'Create external service task',
    'Append service task': 'Add external service task',
    'Service task': 'External service task',
    'Service Task': 'External service task',
    'Required field': 'Required field',
};

export default translationsEn;